import { AuthProvider } from './hooks/useAuth';

import { combineComponents } from './utils/combineComponents';

const providers = [
  AuthProvider,
];
export const AppContextProvider = combineComponents(...providers);
